'use strict';

function splitLabelValueByPart(tooltipValue, part) {
    const breakPoint = 35;
    if (part === 0) {
        if (tooltipValue.length > breakPoint * 2) {
            const sliceIndex = tooltipValue.slice(0, tooltipValue.length / 3).lastIndexOf(' ');
            return tooltipValue.slice(0, sliceIndex)
        }
        return ''
    }
    if (part === 1) {
        if (tooltipValue.length > breakPoint * 2) {
            const sliceIndex = tooltipValue.slice(0, tooltipValue.length / 3).lastIndexOf(' ');
            const sliceIndexEnd = tooltipValue.slice(sliceIndex, (tooltipValue.length / 3) * 2).lastIndexOf(' ');
            return tooltipValue.slice(sliceIndex+1, sliceIndex + sliceIndexEnd)
        }
        if (tooltipValue.length > breakPoint) {
            const sliceIndex = tooltipValue.slice(0, tooltipValue.length / 2).lastIndexOf(' ');
            return tooltipValue.slice(0, sliceIndex)
        }
        return tooltipValue
    }
    if (part === 2) {
        if (tooltipValue.length > breakPoint * 2) {
            const sliceIndex = tooltipValue.slice(0, tooltipValue.length / 3).lastIndexOf(' ');
            const sliceIndexEnd = tooltipValue.slice(sliceIndex, (tooltipValue.length / 3) * 2).lastIndexOf(' ');
            return tooltipValue.slice(sliceIndex + sliceIndexEnd+1)
        }
        if (tooltipValue.length > breakPoint) {
            const sliceIndex = tooltipValue.slice(0, tooltipValue.length / 2).lastIndexOf(' ');
            return tooltipValue.slice(sliceIndex+1)
        }
        return ''
    }
    return ''
}
export default [
    '$utils',
    ($utils) => {
        /**
         * @param params
         * @param params.title
         * @param params.legendPosition
         * @param params.hideLegend
         *
         * Docs:
         * https://www.chartjs.org/docs/latest/
         * https://github.com/emn178/chartjs-plugin-labels
         */
        
        function getDoghnutChartOptions(params = {}) {
            let pieChartParams = {
                animation: {
                    duration: 0
                },
                cutoutPercentage: 70,
                devicePixelRatio: 2,
                maintainAspectRatio: false,
                plugins: {
                    labels: {
                        render: 'percentage',
                        showZero: false,
                        fontStyle: 'bold',
                        position: 'center',
                        textMargin: 10,
                        fontColor: "#333"
                    },
                },
                tooltips: params.unit ? {
                    enabled: true,
                    mode: 'nearest',
                    intersect: true,
                    callbacks: {
                        label: (tooltipItem, data) => {
                            const { datasets, labels } = data;
                            const { index, datasetIndex } = tooltipItem;
                            const value = Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(datasets[datasetIndex].data[index]);
                            const tooltipValue = `${labels[index]}: ${value}${params.unit ? ` ${params.unit}` : ''}`;
                            return splitLabelValueByPart(tooltipValue, 1)
                        },
                        beforeLabel: (tooltipItem, data) => {
                            const { datasets, labels } = data;
                            const { index, datasetIndex } = tooltipItem;
                            const value = Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(datasets[datasetIndex].data[index]);
                            const tooltipValue = `${labels[index]}: ${value}${params.unit ? ` ${params.unit}` : ''}`;
                            return splitLabelValueByPart(tooltipValue, 0)
                        },
                        afterLabel: (tooltipItem, data) => {
                            const { datasets, labels } = data;
                            const { index, datasetIndex } = tooltipItem;
                            const value = Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(datasets[datasetIndex].data[index]);
                            const tooltipValue = `${labels[index]}: ${value}${params.unit ? ` ${params.unit}` : ''}`;
                            return splitLabelValueByPart(tooltipValue, 2)
                        },
                    },
                } : {},
            };

            if (params.title) {
                pieChartParams.title = {
                    display: true,
                    text: params.title,
                    fontSize: 16,
                    padding: 15,
                };
            }

            if (!params.hideLegend) {
                pieChartParams.legend = {
                    display: true,
                    position: params.legendPosition
                        ? params.legendPosition
                        : 'right',
                    fullWidth: false,
                    labels: {
                        // This more specific font property overrides the global property
                        fontSize: 10,
                        padding: 6,
                    }
                };
            }

            if (params.hideLabels) {
                pieChartParams.plugins.labels.fontSize = 0;
            }

            return pieChartParams;
        }

        /**
         * @param params
         * @param params.title
         * @param params.legendPosition
         * @param params.hideLegend
         *
         * Docs:
         * https://www.chartjs.org/docs/latest/
         * https://github.com/emn178/chartjs-plugin-labels
         */
        
        function getPieChartOptions(params = {}) {
            let pieChartParams = {
                animation: {
                    duration: 0
                },
                devicePixelRatio: 2,
                maintainAspectRatio: false,
                plugins: {
                    labels: {
                        render: 'percentage',
                        showZero: false,
                        fontStyle: 'bold',
                        position: 'border',
                        textMargin: 10,
                        fontColor: "#333"
                    },
                },
                tooltips: params.unit ? {
                    enabled: true,
                    mode: 'nearest',
                    intersect: true,
                    callbacks: {
                        label: (tooltipItem, data) => {
                            const { datasets, labels } = data;
                            const { index, datasetIndex } = tooltipItem;
                            const value = Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(datasets[datasetIndex].data[index]);
                            const tooltipValue = `${labels[index]}: ${value}${params.unit ? ` ${params.unit}` : ''}`;
                            return splitLabelValueByPart(tooltipValue, 1)
                        },
                        beforeLabel: (tooltipItem, data) => {
                            const { datasets, labels } = data;
                            const { index, datasetIndex } = tooltipItem;
                            const value = Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(datasets[datasetIndex].data[index]);
                            const tooltipValue = `${labels[index]}: ${value}${params.unit ? ` ${params.unit}` : ''}`;
                            return splitLabelValueByPart(tooltipValue, 0)
                        },
                        afterLabel: (tooltipItem, data) => {
                            const { datasets, labels } = data;
                            const { index, datasetIndex } = tooltipItem;
                            const value = Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(datasets[datasetIndex].data[index]);
                            const tooltipValue = `${labels[index]}: ${value}${params.unit ? ` ${params.unit}` : ''}`;
                            return splitLabelValueByPart(tooltipValue, 2)
                        },
                    },
                } : {},
            };

            if (params.title) {
                pieChartParams.title = {
                    display: true,
                    text: params.title,
                    fontSize: 16,
                    padding: 15,
                };
            }

            if (!params.hideLegend) {
                pieChartParams.legend = {
                    display: true,
                    position: params.legendPosition
                        ? params.legendPosition
                        : 'right',
                    fullWidth: false,
                    labels: {
                        // This more specific font property overrides the global property
                        fontSize: 10,
                        padding: 6,
                    }
                };
            }

            if (params.hideLabels) {
                pieChartParams.plugins.labels.fontSize = 0;
            }

            return pieChartParams;
        }

        /**
         * @param params
         * @param params.title
         * @param params.legendPosition
         * @param params.hideLegend
         * @param params.stackYAxe
         * @param params.stackXAxe
         * @param params.maxYValue
         * @param params.minYValue
         * @param params.yAxeType
         * @param params.hideLabels
         * @param params.indexAxis
         * @param params.unit
         * @param params.xAxeBarPercentage
         * @param params.xAxeCategoryPercentage
         * @param params.defaultTooltip
         *
         * Docs:
         * https://www.chartjs.org/docs/latest/
         * https://github.com/emn178/chartjs-plugin-labels
         */
        function getBarChartOptions(params = {}) {
            let barChartParams = {
                maintainAspectRatio: false,
                devicePixelRatio: 2,
                plugins: {
                    labels: {
                        fontSize: 11,
                        render: args => Intl.NumberFormat('en-US', { maximumFractionDigits: 2 })
                            .format(args.value),
                        showZero: false,
                        overlap: false,
                    },
                },
                indexAxis: 'x',
                scales: {
                    xAxes: [{
                        ticks: {},
                    }],
                    yAxes: [{
                        ticks: {
                            callback: (tickValue, index, ticks) => {
                                var remain = tickValue / (Math.pow(10, Math.floor($utils.log10(tickValue))));

                                if (tickValue === 0) {
                                    return '0';
                                } else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
                                    return Intl.NumberFormat('en-US', { maximumFractionDigits: 2 })
                                        .format(Number(tickValue.toString()));
                                }
                                return '';
                            },
                        },
                    }],
                },
                tooltips: params.defaultTooltip ? {} : {
                    enabled: true,
                    mode: 'nearest',
                    intersect: true,
                    callbacks: {
                        label: (tooltipItem, data) => `${data.datasets[tooltipItem.datasetIndex].label}: ${Intl.NumberFormat('en-US', { maximumFractionDigits: 2 })
                            .format(tooltipItem.value)}${params.unit ? ` ${params.unit}` : ''}`,
                    },
                },
            };

            if (params.indexAxis) {
                barChartParams.indexAxis = params.indexAxis
            }

            if (params.hideLabels) {
                barChartParams.plugins.labels.fontSize = 0;
            }

            if (params.title) {
                barChartParams.title = {
                    display: true,
                    text: params.title,
                    fontSize: 16,
                    padding: 15,
                };
            }

            if (!params.hideLegend) {
                barChartParams.legend = {
                    display: true,
                    position: params.legendPosition
                        ? params.legendPosition
                        : 'right',
                    fullWidth: false,
                };
            }

            if (params.stackXAxe) {
                barChartParams.scales.xAxes[0].stacked = true;
            }

            if (params.stackYAxe) {
                barChartParams.scales.yAxes[0].stacked = true;
            }

            if (params.minYValue !== null && !angular.isUndefined(params.minYValue)) {
                barChartParams.scales.yAxes[0].ticks.min = params.minYValue;
            }

            if (params.maxYValue) {
                barChartParams.scales.yAxes[0].ticks.max = params.maxYValue;
            }

            if (params.yAxeType) {
                barChartParams.scales.yAxes[0].type = params.yAxeType;
            }

            if (params.xAxeBarPercentage) {
                barChartParams.scales.xAxes[0].barPercentage = params.xAxeBarPercentage;
            }

            if (params.xAxeCategoryPercentage) {
                barChartParams.scales.xAxes[0].categoryPercentage = params.xAxeCategoryPercentage;
            }

            if (params.removeYAxe) {
                barChartParams.scales.yAxes[0].display = false;
                barChartParams.scales.yAxes[0].drawTicks = false;
            }

            if (params.removeXAxe) {
                barChartParams.scales.xAxes[0].display = false;
                barChartParams.scales.xAxes[0].drawTicks = false;
            }

            return barChartParams;
        }

        /**
         * @param params
         * @param params.title
         * @param params.legendPosition
         * @param params.hideLegend
         * @param params.stackYAxe
         * @param params.stackXAxe
         * @param params.maxYValue
         * @param params.minYValue
         * @param params.xAxeType
         * @param params.hideLabels
         * @param params.indexAxis
         * @param params.unit
         * @param params.yAxeBarPercentage
         * @param params.yAxeCategoryPercentage
         * @param params.defaultTooltip
         *
         * Docs:
         * https://www.chartjs.org/docs/latest/
         * https://github.com/emn178/chartjs-plugin-labels
         */
        function getHorizontalBarChartOptions(params = {}) {
            let horizontalBarChartParams = {
                maintainAspectRatio: false,
                devicePixelRatio: 2,
                plugins: {
                    labels: {
                        fontSize: 11,
                        render: args => Intl.NumberFormat('en-US', { maximumFractionDigits: 2 })
                            .format(args.value),
                        showZero: false,
                        overlap: false,
                    },
                },
                indexAxis: 'y',
                responsive: true,
                scales: {
                    xAxes: [{
                        ticks: {
                            callback: (tickValue, index, ticks) => {
                                var remain = tickValue / (Math.pow(10, Math.floor($utils.log10(tickValue))));

                                if (tickValue === 0) {
                                    return '0';
                                } else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
                                    return Intl.NumberFormat('en-US', { maximumFractionDigits: 2 })
                                        .format(Number(tickValue.toString()));
                                }
                                return '';
                            },
                        },
                    }],
                    yAxes: [{
                        ticks: {},
                    }],
                },
                tooltips: params.defaultTooltip ? {} : {
                    enabled: true,
                    mode: 'nearest',
                    intersect: true,
                    callbacks: {
                        label: (tooltipItem, data) => {
                            return `${data.datasets[tooltipItem.datasetIndex].label}: ${Intl.NumberFormat('en-US', { maximumFractionDigits: 2 })
                                .format(tooltipItem.value)}${params.unit ? ` ${params.unit}` : ''}`
                        }
                    },
                },
            };

            if (params.indexAxis) {
                horizontalBarChartParams.indexAxis = params.indexAxis
            }

            if (params.hideLabels) {
                horizontalBarChartParams.plugins.labels.fontSize = 0;
            }

            if (params.title) {
                horizontalBarChartParams.title = {
                    display: true,
                    text: params.title,
                    fontSize: 16,
                    padding: 15,
                };
            }

            if (!params.hideLegend) {
                horizontalBarChartParams.legend = {
                    display: true,
                    position: params.legendPosition
                        ? params.legendPosition
                        : 'right',
                    fullWidth: false,
                };
            }

            if (params.stackXAxe) {
                horizontalBarChartParams.scales.xAxes[0].stacked = true;
            }

            if (params.stackYAxe) {
                horizontalBarChartParams.scales.yAxes[0].stacked = true;
            }

            if (params.minYValue !== null && !angular.isUndefined(params.minYValue)) {
                horizontalBarChartParams.scales.yAxes[0].ticks.min = params.minYValue;
            }

            if (params.maxYValue) {
                horizontalBarChartParams.scales.yAxes[0].ticks.max = params.maxYValue;
            }
            if (params.maxXValue) {
                horizontalBarChartParams.scales.xAxes[0].ticks.max = params.maxXValue;
            }

            if (params.xAxeType) {
                horizontalBarChartParams.scales.xAxes[0].type = params.xAxeType;
            }

            if (params.yAxeRemove) {
                horizontalBarChartParams.scales.yAxes[0].display = false;
            }

            if (params.xAxeRemove) {
                horizontalBarChartParams.scales.xAxes[0].display = false;
            }

            if (params.yAxeBarPercentage) {
                horizontalBarChartParams.scales.yAxes[0].barPercentage = params.yAxeBarPercentage;
            }

            if (params.yAxeCategoryPercentage) {
                horizontalBarChartParams.scales.yAxes[0].categoryPercentage = params.yAxeCategoryPercentage;
            }

            return horizontalBarChartParams;
        }

        function getRiskAreaBarOptions(params = {}) {
            const baseParams = getHorizontalBarChartOptions(params);
            baseParams.tooltips = {
                mode: 'nearest',
                callbacks: {
                    title: (tooltipItem, data) => {
                        return params.tooltipsData[tooltipItem[0].datasetIndex].title
                    },
                    beforeLabel: (tooltipItem) => tooltipItem ? params.tooltipsData[tooltipItem.datasetIndex].beforeLabel : '',
                    label: (tooltipItem) => tooltipItem ? params.tooltipsData[tooltipItem.datasetIndex].label : '',
                    afterLabel: (tooltipItem) => tooltipItem ? params.tooltipsData[tooltipItem.datasetIndex].afterLabel : '',
                },
            }
            return baseParams
        }

        return {
            getPieChartOptions,
            getBarChartOptions,
            getHorizontalBarChartOptions,
            getDoghnutChartOptions,
            getRiskAreaBarOptions,
        };
    },
];
